import ReactGA from 'react-ga';

export const callAnalytics = (page) => {
	try {
		ReactGA.initialize('UA-146600974-1');
		ReactGA.set({ page });
		ReactGA.pageview(page);
	} catch (error) {}
}